<template>
<!-- 体检 报告 -->
  <el-scrollbar class="x_scroll" style="height: 100%">
    <div class="header clearfix">
      <el-button v-if="type!==1" type="primary" size="small" @click="handleAdd" class="">添加报告</el-button>
    </div>
    <template v-if="list.length">
      <el-descriptions v-for="item in list" :key="item.id"  class="margin-top descriptions" :title="item.reportName" :column="1" direction="horizontal" border>
        <template slot="extra">
          <el-button type="primary" @click="handleView(item)" size="small">查看</el-button>
        </template>
        <el-descriptions-item label="体检时间">{{item.examinationDate}}</el-descriptions-item>
        <el-descriptions-item label="解读时间">{{item.createTime}}</el-descriptions-item>
      </el-descriptions>
    </template>
    <el-empty v-else description="描述文字"></el-empty>
      <!-- 添加治疗史 -->
    <el-dialog
      title="添加治疗史"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose">
      <el-form label-width="120px" class="form" ref="form" :rules="rules" :model="form" label-position="right">
        <el-form-item label="报告名称:" :label-width="formLabelWidth" prop="reportName">
          <el-input v-model="form.reportName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="体检时间:" :label-width="formLabelWidth" prop="examinationDate">
          <el-date-picker
            v-model="form.examinationDate"
            type="datetime"
            value-format="yyyy-MM-dd"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="调理史:" :label-width="formLabelWidth" prop="reportUrl">
            <upload-image :imgLength="9" :imageArr="form.reportUrl" @success="onSuccess2" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-debounce="onSave">确认</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog >
    <!-- 展示图片 -->
    <el-dialog title="查看图片" :visible.sync="open" append-to-body width="500px">
      <el-image 
        v-for="(item,index) in srcList" :key="index"
        style="width: 100px; height: 100px"
        :src="item" 
        :preview-src-list="srcList">
      </el-image>
    </el-dialog>
  </el-scrollbar>
</template>

<script>
import {memberMedicExaminationReportInsert, workOrderDetailById} from '@/api/system/member'
import {deepClone} from '@/utils/index'
import uploadImage from '../uploadImage.vue';
export default {
    components: {
    uploadImage
  },
    props: {
      type: {  // 1 为会员 2为建档
      default: 1,
      type: Number
    },
    memberId: {
      type: Number,
      default() {
        return null
      }
    },
    memberInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      detail: {},
      open: false,
      srcList: [],
      form: {},
      dialogVisible: false,
      formLabelWidth: '100px',
      rules: {
        reportName:[{required: true, message: '请输入',trigger: 'blur'}],
        examinationDate:[{required: true, message: '请选择',trigger: 'change'}],
        reportUrl:[{required: true, message: '请上传',trigger: 'change'}],
      }
    }
  },
  created() {
  },
  methods: {
    //查询工单详情byid
    handleDetaillById(id) {
      return new Promise((resolve, reject) => {
        workOrderDetailById({workOrderNum:id}).then(res => {
          if(res.code === 200) {
            // this.detail = res.data
            resolve(res.data)
          }
        })
      })
    },
    // 查看
    handleView(item) {
      // type=4&memberId=70&enterpriseId=14&workOrderId=GD-20210803-83989002&serviceId=18
      if(item.reportType ===1 ) {
        this.open = true
        this.srcList = item.reportUrl
      }else {
        // this.handleDetaillById(item.remark).then(res => {
        //   const query = { memberId: item.memberId, workOrderId: item.remark, serviceId: res?.serviceId }
        //   query.type = item.reportType === 2? 4: 5
        //   this.$router.push({ path: '/health_plan', query: query })
        // })
        return
        // item.reportType ===2
        // 疾病风险评估
      }
    },
     onSave() {
      this.$refs['form'].validate((valid) => {
          if (valid) {
            // alert('submit!');
            const data = deepClone(this.form)
            const url = this.form?.reportUrl
            data.memberId = this.memberInfo?.id
            data.memberName = this.memberInfo?.memberName
            data.reportUrl = url
            memberMedicExaminationReportInsert(data).then(res => {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.$emit('success')
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
    // 检查报告
    onSuccess2(url) {
      // this.form.reportUrl = url
      this.$set(this.form, 'reportUrl', url)
        //console.log(url)
    },
    // 新增对话框
    handleAdd() {
      this.dialogVisible = true
    },
    handleClose() {
      console.log('into=====>');
      this.resetForm('form')
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
  .form ::v-deep .el-form-item__content {
    width: 300px;
  }
    .descriptions {
    margin-bottom: 16px;
  }
</style>